import Vue from 'vue'
import Moment from 'moment'

Moment.locale('uk')

Vue.filter('date', function (value, formatType = 'long') {
  if (formatType === 'short') {
    return Moment(new Date(value)).format('L')
  } else if (formatType === 'long') {
    return Moment(new Date(value)).format('LL')
  } else {
    return Moment(new Date(value)).format(formatType)
  }
})

Vue.filter('dateTime', function (value) {
  return Moment.parseZone(new Date(value)).format('DD.MM.YYYY HH:mm:ss')
})

Vue.filter('dateBirth', function (value) {
  const date = Moment(new Date(value))
  return Moment().diff(date, 'years')
})
